import forge from 'node-forge';

const prefix = '-----BEGIN PUBLIC KEY-----\n';
const suffix = '\n-----END PUBLIC KEY-----';

const encrypt = function (message, publicKey) {
    const pem = prefix + publicKey + suffix;
    const oPublicKey = forge.pki.publicKeyFromPem(pem);

    const msg = oPublicKey.encrypt(message, "RSA-OAEP", {
        md: forge.md.sha256.create(),
        mgf1: {
            md: forge.md.sha1.create()
        }
    });

    return forge.util.encode64(msg);
};

export default encrypt;
